<template>
	<section style="padding:20px;">
		Form Test Component
		<div style="font-size:11px;">
			<pre>{{ formData }}</pre>
		</div>
		<Forms ref="testForm" :formDefinition="formDefinition" style="width:300px;"/>
		<div>
			<button type="button" class="btn btn-primary" @click="saveForm()">Save</button>
		</div>
	</section>
</template>

<script>
import { defineComponent } from 'vue';
import Forms from '@/components/schreg-common/Forms/Forms.vue';
import { baseComponentMixin } from '@/mixins/baseComponent.mixin';

export default defineComponent({
	name: 'FormTestComponent',
	config: {
		key: 'schreg.testForm',
		devPath: 'form-test',
		exported: false
	},
	components: {
		Forms
	},
	mixins: [
		baseComponentMixin
	],
	data() {
		return {
			formData: [],
			formDefinition: [
				{
					groupName: 'Input Data',
					fields: [
						{
							type: 'text',
							fieldName: 'inputData',
							fieldPrompt: 'Any Data Here'
						}
					]
				}
			]
		};
	},
	methods: {
		saveForm() {
			if (this.$refs.testForm.validate()) {
				this.formData.push(this.$refs.testForm.values());
			}
		}
	}
});
</script>
